module.exports = __webpack_public_path__ + "img/img_ch1.f1cb7ac6.jpg";